<script>
export default {
  methods: {
    replaceVariables(text) {
      const element = document.createElement('div');
      element.innerHTML = text;
      const variables = element.querySelectorAll('[data-quill-type="variable"]');

      variables.forEach(variable => {
        let type = variable.getAttribute('data-value');
        const name = type.split(':')[0];
        let text = this.$store.state.page.variables[name];

        if (!text) {
          variable.innerText = '';
          return;
        }

        text = decodeURI(text.toString());
        if (type.split(':')[1] === 'uppercase') text = text.toUpperCase();

        variable.innerText = text;
      });

      return element.innerHTML;
    },
  },
};
</script>
